import { useUnitOfMeasureTranslation } from 'support/helpers/orderForms/orderForms';
import { OrderFormProductDTO } from 'support/types/dtos';

export const OrderProductQuantityAndUnitMeasure = ({
  quantity,
  product,
}: {
  quantity: number;
  product: OrderFormProductDTO;
}) => {
  const unitOfMeasure = useUnitOfMeasureTranslation({
    unitOfMeasure: product.unit_of_measure,
    format: 'short',
  });
  return (
    <div className="flex flex-col items-end gap-1">
      <div data-testid="ordered-product-quantity" className="text-xs font-normal text-gray-500">
        {quantity}
        {unitOfMeasure}
      </div>
    </div>
  );
};
